import React from "react";
import { Icon } from "components/Structure/IconComponent";
import { useSkin } from "@hooks/useSkin";
import * as S from "./wrapperArquivaMix.styles";

export const WrapperArquivaMix = ({
  children,
  overlayContent,
  buttonText = "✨ Contrate nosso serviço ✨",
  modalWidth = "800px",
  maxHeight = "auto",
}) => {
  const { skin } = useSkin();

  return (
    <S.WrapperContainer>
      <S.BlurredContent>{children}</S.BlurredContent>
      <S.ModalOverlay>
        <S.ModalCard
          skin={skin}
          modalWidth={modalWidth}
          maxHeight={maxHeight}
          className={skin === "dark" && `border-primary `}
        >
          <S.ModalContent isCentered={!overlayContent}>
            {overlayContent ? (
              overlayContent
            ) : (
              <>
                <S.LockIconContainer skin={skin}>
                  <Icon name="cadeado" color="#7367f0" size={64} />
                </S.LockIconContainer>
                <S.ModalTitle skin={skin}>Conteúdo exclusivo</S.ModalTitle>
                <S.ModalDescription skin={skin} className="m-0">
                  Desbloqueie acesso completo a todos os recursos premium e
                  transforme sua experiência hoje mesmo!
                </S.ModalDescription>
              </>
            )}
          </S.ModalContent>

          <S.CTAButton>
            <S.ButtonText>{buttonText}</S.ButtonText>
          </S.CTAButton>
        </S.ModalCard>
      </S.ModalOverlay>
    </S.WrapperContainer>
  );
};
